import Button from '@ingka/button';
import documentIcon from '@ingka/ssr-icon/paths/document';
import Text from '@ingka/text';
import Tooltip from '@ingka/tooltip';
import { translate } from '@repo/phrase';
import type { SignRequestRow } from '@repo/types/docusign';
import { formatDateTime } from '@repo/utils';

import { getStatusDateLabel } from '@/utils/docusign.utils';
import { getAppConfig } from '@/utils/window.utils';

import { SignaturesStatusViewStatusBadge } from '../signatures-status-view-status-badge/signatures-status-view-status-badge.component';
import { useDocumentView } from './signatures-status-view.hooks';

import styles from './styles.module.scss';

interface Props {
    rows: SignRequestRow[];
}

export const SignaturesStatusView = ({ rows }: Props) => {
    const { viewDocument, isProcessing } = useDocumentView();

    return (
        <div className={styles.list} data-testid="signatures-status-view">
            {rows.map((row) => {
                return (
                    <div key={row.id} className={styles.row}>
                        <div className={styles.colDoc}>
                            <Text tagName="span" textStyle="Body.S" className={String(styles.docLabel)}>
                                {`${translate('docusign_envelope_template')}: ${row.documentLabel}`}
                            </Text>
                            <Text tagName="span" textStyle="Body.S" className={String(styles.docId)}>
                                {`${translate('docusign_envelope_id')}: ${row.id.slice(0, 8)}`}
                            </Text>
                        </div>
                        <div className={styles.colStatus}>
                            <SignaturesStatusViewStatusBadge status={row.status} />
                            <Text tagName="span" textStyle="Body.S" className={String(styles.subTime)}>
                                {`${getStatusDateLabel(row.status)}: ${formatDateTime(row.statusDate, getAppConfig().dateTimeFormat)}`}
                            </Text>
                        </div>
                        <div className={styles.colAction}>
                            {row.status === 'SIGNED' && (
                                <Tooltip
                                    describedById={`view-doc-${row.id}`}
                                    tooltipText={translate('docusign_view_document')}
                                    position="bottom"
                                >
                                    <Button
                                        type="primary"
                                        iconOnly
                                        ssrIcon={documentIcon}
                                        size="small"
                                        data-testid={`signatures-view-${row.id}`}
                                        onClick={() => void viewDocument(row.id)}
                                        loading={isProcessing(row.id)}
                                        disabled={isProcessing(row.id)}
                                        aria-label={translate('docusign_view_document')}
                                    />
                                </Tooltip>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
